import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const getContributors = (
  searchInput: string,
  currentPage: number
): Promise<any> =>
  apiClient(
    `/v1/org/${getOrgId()}/contributors${`?pageNo=${currentPage}&pageSize=${20}`} ${
      searchInput ? `&searchTerm=${searchInput}` : ''
    }`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
